import {
  Form,
  StickyButton,
  Button,
  ModalLayout,
} from '@Knowledge-OTP/znk-ui-components'
import React, { useEffect, useState } from 'react'
// import {useSelector} from 'react-redux'
import { isEmpty } from 'validate.js'
import useTranslation from '../../../../../i18n/useTranslation'
import sendTopicsTeach from './Model/sendTopicsTeach'
// import TopicSelection from '../../../../Calendar/Lessons/Modal/NewLesson/TopicSelection'
import TopicSelectionTeaching from './topicSelection'

const SendTeachTopics = (props) => {
  //eslint-disable-next-line
  const { isOpen, setIsOpen, canTeach, otherServices, userId } = props
  console.log(canTeach)
  // const services = useSelector((state) => state.services.services)
  const [topicsSelections, setTopicSelections] = useState([{ serviceId: null, topics: null }])
  const [form, setForm] = useState({ body: [] })
  const { translate } = useTranslation()
  const [errors, setErrors] = useState(false)
  const toggle = () => {
    setErrors({})
    setIsOpen(!isOpen)
  }
  function transformServices(data) {
    return data.flatMap(item => {
      if (!item.topics || item.topics.length === 0) {
        // Si no hay topics, devolvemos un objeto con topicId: null
        return [{ serviceId: item.serviceId, topicId: null }];
      }

      // Si hay topics, devolvemos uno por cada topicId
      return item.topics.map(topicId => ({
        serviceId: item.serviceId,
        topicId
      }));
    });
  }



  useEffect(() => {
    if (canTeach) {
      setForm({ body: transformServices(canTeach) })
      setTopicSelections(transformServices(canTeach))
    }
  }, [canTeach])
  const { submit, loading } = sendTopicsTeach(() => {
    toggle()
  }, console.log)
  const onSubmit = () => {
    setErrors({})
    // Filter out empty selections and check if any topics are selected
    // const finalSelections = topicsSelections.body.filter(s => s?.serviceId);
    const finalSelections = topicsSelections.filter(s => s?.serviceId);
    if (isEmpty(finalSelections)) {
      setErrors(true)
      return
    }
    // Also check that the last item is not partially filled
    //eslint-disable-next-line
    const lastItem = form.body[form.body.length - 1];
    // if (lastItem.serviceId && !lastItem.topics) { setErrors(true); return; }

    const payload = finalSelections.map(({ serviceId, topicId }) => ({
      serviceId,
      topicId,

    }));
    submit({ otherServices: payload, userId })
  }
  return (
    <>
      <div className='m-0 p-0 w-100 h-70' onClick={toggle}>
        {props.children}
      </div>
      <ModalLayout
        buttonLabel={null}
        className='modal-centered-full h-auto'
        isOpen={isOpen}
        toggle={toggle}
        backdrop={true}
        style={{ border: 'none', boxShadow: 'none', borderRadius: '12px' }}
        topHead={
          <div className='d-flex flex-column align-items-start px-4 pb-0 my-3'>
            <span className='flex-grow-1 text-title font-weight-bold h2'>
              {translate('profile.actions.employmentdetails.sendtopics')}
            </span>
            <label className='text-gray font-weight-light mt-3 mb-4'>
              {translate('profile.actions.employmentdetails.bodytext')}
            </label>
          </div>
        }
      >
        <div className='m-0 p-0 mb-2 px-3'>
          <Form>
            {/* <label className='text-gray font-weight-light mt-3 mb-4'>
              {translate('profile.actions.employment.bodytext')}
            </label> */}
            <TopicSelectionTeaching selectionsArray={topicsSelections} setSelectionsArray={setTopicSelections} />
            {errors === true && (
              <span className='h5 text-error'>
                {translate('profile.actions.employment.errorbodytext')}
              </span>
            )}
            <div className='row d-flex m-0 p-0 mt-5'>
              <div className='col-12 p-0 '>
                <StickyButton>
                  <div className='m-0 p-0 row'>
                    <Button
                      color='primary'
                      activity={loading}
                      className='col-12 aling-text-left'
                      label='Save'
                      onClick={onSubmit}
                      style={{ borderRadius: '16px' }}
                      check='yes'
                    />
                  </div>
                </StickyButton>
              </div>
            </div>
          </Form>
        </div>
      </ModalLayout>
    </>
  )
}

export default SendTeachTopics
